// extracted by mini-css-extract-plugin
export default {"header":"card_header__b-eHV","card":"card_card__ivTJq","cardContainer":"card_cardContainer__Bira9"};